module.exports = __webpack_public_path__ + "img/about2.8956aef2.png";